<figure class="figure">
  <img
    class="figure__img"
    [src]="imageAsset.url"
    [alt]="imageDesc"
    [ngClass]="{ 'figure__img--zoom-out' : isImageZoom }">
  <figcaption class="figure__caption figure__caption--{{ attPosition }}" *ngIf="imageAsset.source === 'Unsplash'">
    <a href="{{ imageAsset.photographerProfileUrl }}" target="_blank" rel="noopener noreferrer">
      <cite>{{ imageAsset.photographerName }}</cite>
    </a>
    <span> on</span>
    <a href="https://unsplash.com/?utm_source=bulb&utm_medium=referral" target="_blank" rel="noopener noreferrer">
      Unsplash
    </a>
  </figcaption>
</figure>
